import React from 'react';
import { useOrderBookClearLog } from '../api/hooks';

function fmtTs(unix) {
  if (unix == null || !Number.isFinite(Number(unix))) return '—';
  try {
    return new Date(Number(unix) * 1000).toLocaleString();
  } catch {
    return '—';
  }
}

function fmtNum(v, d = 4) {
  if (v == null || Number.isNaN(Number(v))) return '—';
  return Number(v).toFixed(d);
}

/** Currency-like amounts for OB depth (two decimals). */
function fmtUsd2(v) {
  if (v == null || !Number.isFinite(Number(v))) return '—';
  return Number(v).toFixed(2);
}

/**
 * Audit log of OB clears (manual ladder + entry-driven consumes), backed by PG.
 */
export default function OrderBookClearLog({ marketKey }) {
  const { data, isLoading, error } = useOrderBookClearLog(marketKey, 150);
  const events = data?.events ?? [];

  if (!marketKey) {
    return <div className="empty-state compact">Select a market to view the clear log.</div>;
  }

  if (isLoading && !data) {
    return <div className="empty-state compact">Loading clear log…</div>;
  }

  if (error) {
    return <div className="ob-error">Could not load clear log: {error.message || String(error)}</div>;
  }

  if (events.length === 0) {
    return (
      <div className="empty-state compact">
        No OB clears recorded for this market yet (manual clears or entry-driven OB path).
      </div>
    );
  }

  return (
    <>
      <div className="ob-clear-log-wrap">
        <table className="ob-clear-log-table">
        <thead>
          <tr>
            <th>Time</th>
            <th>Src</th>
            <th>Side</th>
            <th>Level</th>
            <th>Action</th>
            <th>OB removed ($)</th>
            <th>At rung ($)</th>
            <th>Rungs</th>
            <th>p fair →</th>
            <th>z²</th>
            <th>y</th>
            <th>R</th>
          </tr>
        </thead>
        <tbody>
          {events.map((row) => (
            <tr key={row.id}>
              <td>{fmtTs(row.event_ts)}</td>
              <td>{row.source || '—'}</td>
              <td>{row.side || '—'}</td>
              <td>{row.level_index != null ? row.level_index : '—'}</td>
              <td>{row.ob_action || '—'}</td>
              <td>{row.stake_cleared != null ? fmtUsd2(row.stake_cleared) : '—'}</td>
              <td>
                {row.stake_cleared_rung != null && Number.isFinite(Number(row.stake_cleared_rung))
                  ? fmtUsd2(row.stake_cleared_rung)
                  : '—'}
              </td>
              <td>{row.n_clears != null ? row.n_clears : '—'}</td>
              <td>
                {fmtNum(row.p_fair_before, 3)} → {fmtNum(row.p_fair_after, 3)}
              </td>
              <td>{fmtNum(row.z2, 3)}</td>
              <td>{fmtNum(row.y_obs, 3)}</td>
              <td>{fmtNum(row.R_obs, 3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </>
  );
}
